import {
  PROPERTY_TYPE_CHECKBOX, PROPERTY_TYPE_DATE,
  PROPERTY_TYPE_EMAIL,
  PROPERTY_TYPE_MULTI_SELECT, PROPERTY_TYPE_NUMBER, PROPERTY_TYPE_PHONE_NUMBER, PROPERTY_TYPE_RICH_TEXT,
  PROPERTY_TYPE_SELECT,
  PROPERTY_TYPE_STATUS, PROPERTY_TYPE_TITLE, PROPERTY_TYPE_URL,
} from 'shared/services/notion-constants';

export const getIconForType = (type) => {
  switch (type) {
    case PROPERTY_TYPE_MULTI_SELECT:
      return 'bars';
    case PROPERTY_TYPE_SELECT:
      return 'single-select';
    case PROPERTY_TYPE_STATUS:
      return 'status';
    case PROPERTY_TYPE_EMAIL:
      return 'email';
    case PROPERTY_TYPE_NUMBER:
      return 'number';
    case PROPERTY_TYPE_RICH_TEXT:
    case PROPERTY_TYPE_TITLE:
      return 'align-left';
    case PROPERTY_TYPE_URL:
      return 'link';
    case PROPERTY_TYPE_CHECKBOX:
      return 'check-square';
    case PROPERTY_TYPE_PHONE_NUMBER:
      return 'phone';
    case PROPERTY_TYPE_DATE:
      return 'calendar';
    default:
      return '';
  }
};
